<div>
  <div class="card-info-label">
    {{ datapoint.label }}
  </div>
  <div
    class="card-info-value {{
      datapoint.varName !== 'RepCode' &&
      datapoint.varName !== 'AccountNumDisplay'
        ? 'mb-2'
        : 'mb-1'
    }}"
  >
    @if (dataset) {
      @if (datapoint.varSet) {
        <!-- Displays for nested varset -->
        @if (datapoint.valueMask === 'date') {
          {{ dataset[datapoint.varSet][datapoint.varName] | date: 'shortDate' }}
        } @else if (datapoint.valueMask && datapoint.valueMask === 'currency') {
          {{ dataset[datapoint.varSet][datapoint.varName] | currency }}
        } @else if (datapoint.valueMask && datapoint.valueMask === 'percent') {
          {{ dataset[datapoint.varSet][datapoint.varName] | percent }}
        } @else if (datapoint.valueMask && datapoint.valueMask === 'integer') {
          {{ dataset[datapoint.varSet][datapoint.varName] | number: '1.0-0' }}
        } @else if (datapoint.varName === 'GroupID' && dataset.AccountGroup) {
          <button
            type="button"
            class="detail-link-button"
            mat-stroked-button
            matTooltip="View Group"
            [matTooltipPosition]="'above'"
            (click)="
              nav(
                'account-grouping/' + dataset.AccountGroup[datapoint.varName],
                true
              )
            "
          >
            <mat-icon>launch</mat-icon>
            {{ dataset.AccountGroup[datapoint.varName] }}
          </button>
        } @else if (
          dataset['RepProfile'] &&
          dataset['RepProfile'][datapoint.varSet][datapoint.varName]
        ) {
          <!-- Rep review specific datapoint -->
          {{ dataset['RepProfile'][datapoint.varSet][datapoint.varName] }}
        } @else {
          {{ dataset[datapoint.varSet][datapoint.varName] }}
        }
      } @else {
        <!-- Displays for non-nested vars -->
        @if (datapoint.key) {
          {{ datapoint.key[dataset[datapoint.varName]] }}
        } @else if (
          datapoint.varName === 'RepCode' &&
          rights.includes('RepReview') &&
          dataset['Rep'] &&
          dataset['Rep']['RepID_Rev']
        ) {
          <button
            type="button"
            class="detail-link-button"
            mat-stroked-button
            [matTooltip]="
              'FP Score: ' +
              (dataset['Rep']
                ? dataset['Rep']['ScoreClass']
                : dataset['ScoreClass'])
            "
            [matTooltipPosition]="'above'"
            (click)="nav('rep-review/' + dataset['Rep']['RepID_Rev'])"
          >
            <span
              [class]="
                'detail-score-indicator me-1 ' +
                (dataset['Rep']
                  ? dataset['Rep']['ScoreClass']
                  : dataset['ScoreClass'])
              "
            ></span>
            {{ dataset[datapoint.varName] }}
          </button>
        } @else if (
          datapoint.varName === 'RepCode' &&
          rights.includes('RepReview') &&
          dataset['Rep'] &&
          !dataset['Rep']['RepID_Rev']
        ) {
          <span
            tabindex="0"
            matTooltip="Details Record is Currently Unavailable"
            class="detail-link-button unclickable-link"
          >
            {{ dataset[datapoint.varName] }}
          </span>
        } @else if (
          datapoint.varName === 'RepCode' && !rights.includes('RepReview')
        ) {
          <span
            [class]="
              'detail-score-indicator me-1 ' +
              (dataset['Rep']
                ? dataset['Rep']['ScoreClass']
                : dataset['ScoreClass'])
            "
          ></span>
          {{ dataset[datapoint.varName] }}
        } @else if (
          datapoint.varName === 'AccountNumDisplay' &&
          dataset['Account'] &&
          dataset['Account']['AccountNumDisplay'] &&
          rights.includes('AccountReview')
        ) {
          <button
            type="button"
            class="detail-link-button"
            mat-stroked-button
            [matTooltip]="'Account Score: ' + dataset['Account']['ScoreClass']"
            [matTooltipPosition]="'above'"
            (click)="
              nav('account-review/' + dataset['Account']['AccountID_Rev'])
            "
          >
            <span
              [class]="
                'detail-score-indicator me-1 ' +
                dataset['Account']['ScoreClass']
              "
            ></span>
            {{ dataset[datapoint.varName] }}
          </button>

          @if (
            datapoint.decryptTarget &&
            dataset[datapoint.decryptTarget] &&
            !disableDecryption
          ) {
            <button
              type="button"
              class="ms-1 decrypt-button"
              mat-icon-button
              matTooltip="Click to see raw value"
              [matTooltipShowDelay]="500"
              (click)="
                decryptValue(dataset[datapoint.decryptTarget], 'Account #')
              "
            >
              <mat-icon>lock_open</mat-icon>
            </button>
          }
        } @else if (
          datapoint.varName === 'AccountNumDisplay' &&
          dataset['Account'] &&
          !dataset['Account']['AccountNumDisplay'] &&
          rights.includes('AccountReview')
        ) {
          <span
            tabindex="0"
            matTooltip="Account Details Currently Unavailable"
            class="detail-link-button unclickable-link"
          >
            {{ dataset[datapoint.varName] }}
          </span>
        } @else if (
          datapoint.varName === 'AccountNumDisplay' &&
          dataset['Account'] &&
          !rights.includes('AccountReview')
        ) {
          <span
            [class]="
              'detail-score-indicator me-1 ' + dataset['Account']['ScoreClass']
            "
          ></span>
          {{ dataset[datapoint.varName] }}
        } @else if (datapoint.valueMask && datapoint.valueMask === 'date') {
          {{ dataset[datapoint.varName] | date: 'shortDate' }}
        } @else if (datapoint.valueMask && datapoint.valueMask === 'currency') {
          <span>{{ dataset[datapoint.varName] | currency }}</span>
        } @else if (datapoint.valueMask && datapoint.valueMask === 'percent') {
          {{ dataset[datapoint.varName] | percent }}
        } @else if (datapoint.valueMask && datapoint.valueMask === 'integer') {
          {{ dataset[datapoint.varName] | number: '1.0-0' }}
        } @else {
          {{ dataset[datapoint.varName] }}

          @if (
            datapoint.decryptTarget &&
            dataset[datapoint.decryptTarget] &&
            !disableDecryption
          ) {
            <button
              type="button"
              class="ms-1 decrypt-button"
              mat-icon-button
              matTooltip="Click to see raw value"
              [matTooltipShowDelay]="500"
              (click)="
                decryptValue(dataset[datapoint.decryptTarget], 'Account #')
              "
            >
              <mat-icon>lock_open</mat-icon>
            </button>
          }
        }
      }
    }
  </div>
</div>
<ngx-loading [show]="loading" />
